import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgEmailShare = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsx("rect", {
    width: 48,
    height: 48,
    fill: "#ECECEC",
    rx: 24
  }), /*#__PURE__*/_jsx("path", {
    fill: "#504C49",
    fillRule: "evenodd",
    d: "M37.333 16c0-1.466-1.2-2.666-2.666-2.666H13.333A2.675 2.675 0 0 0 10.667 16v16c0 1.467 1.2 2.667 2.666 2.667h21.334c1.466 0 2.666-1.2 2.666-2.667zm-2.666 0L24 22.667 13.333 16zM24 25.334l-10.667-6.667V32h21.334V18.667z",
    clipRule: "evenodd"
  })]
});
export default SvgEmailShare;